/**
 * ! DO NOT TOUCH THIS
 */
export const environment = {
  beUrl: 'https://dev.be.mallora.app/dev/api/',
  mode: 'development',
  isProduction: false,
};
